import {Box, Grid, Alert as MuiAlert} from "@mui/material"
import {styled} from "@mui/material/styles";
import { useColors } from "../../Context/ColorsContext"
import { MediaQuerys } from "../../styles/GlobalStyle";

const drawerWidth = 250;
const { mobile, tablet, desktop } = MediaQuerys;

export const LayoutContainer = styled(Box)(() => (() => {
    const { colors } = useColors(); 
    return {
        minWidth: '100vw',
        minHeight: '100vh',
        backgroundColor: colors.background,
    }
}))

export const Container = styled(Grid)(({theme}) => ({
    padding: 0,
    [theme.breakpoints.up('sm')]: {
        height: '100%'
    },
    [theme.breakpoints.up('md')]: {
        height: '100vh'
    },
}))

export const Content = styled('div')(({theme}) => ({
    minWidth: '100vw',
    margin: 0,
    padding: 0,
    [theme.breakpoints.up('md')]: {
        flexWrap: 'wrap',
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        boxSizing: 'border-box'
    },
}));

export const DrawerHeader = styled('div')(({theme}) => ({
    color: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
    height: 64
}));

export const OfflineAlert = styled(MuiAlert)(({ theme }) => {
  return {
    width: '100%',
    borderRadius: 0,
    justifyContent: 'center',
    padding: '2px 16px',
    minHeight: '25px',
    margin: 0,
    boxSizing: 'border-box',
    lineHeight: 1,
    '& .MuiAlert-icon': {
      fontSize: '14px',
      marginRight: '8px',
      padding: '2px 0',
      display: 'flex',
      alignItems: 'center'
    },
    '& .MuiAlert-message': {
      fontSize: '0.8125rem',
      fontWeight: 500,
      padding: '4px 0',
      display: 'flex',
      alignItems: 'center'
    },
    position: 'sticky',
    top: '64px',
    zIndex: theme.zIndex.drawer - 1
  }
});